<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="批次"
                         width="80"></el-table-column>
        <el-table-column prop="excel_name"
                         label="导出表格名">
          <template slot-scope="scope">
            <el-button type="primary"
                       size="mini"
                       @click="onDownSourceFile(scope.row.id)">{{scope.row.excel_name}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at"
                         label="导出时间"></el-table-column>
        <el-table-column
                         label="类型" v-if="withdrawtype !== '6'">
          <template slot-scope="scope">
            <span v-if="[0, 1].includes(scope.row.withdrawtype)">自主提现</span>
            <span v-if="[2, 3, 4, 5].includes(scope.row.withdrawtype)">批量提现</span>
          </template>
        </el-table-column>
        <el-table-column prop="update_user"
                         label="导出者">
          <template slot-scope="scope">
            <span>{{scope.row.update_user || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isconfirm"
                         label="是否确认">
          <template slot-scope="scope">
            <span v-for="item in isconfirm_map.map"
                  v-if="item.key === scope.row.isconfirm">{{item.value}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="200">
          <template slot-scope="scope">
            <router-link :to="{ path: `/finance/batch-withdraw-detail/${$route.meta.type}/${scope.row.id}`}">
              <el-button type="text"
                         size="mini">查看详情
              </el-button>
            </router-link>

            <el-button type="text"
                       size="mini"
                       @click="showBatchRollbackForm(scope.row.id)"
                       v-if="[3, 4, 5].includes(scope.row.isconfirm) && withdrawtype !== '6'">批量回滚
            </el-button>
            <el-button type="text"
                       size="mini"
                       style="color: #f56c6c"
                       @click="withdrawWx(scope.row.id)"
                       v-if="[5].includes(scope.row.isconfirm) && withdrawtype === '6'">微信提现打款
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <el-dialog class="rollback-upload-dialog"
               title="批量回滚"
               :visible.sync="dialogBatchRollbackFormVisible"
               @closed="onClosedBatchRollbackForm"
               :center="true">
      <el-row class="rollback-upload-row">
        <span>开始时间：</span>
        <el-date-picker
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="batchRollbackForm.starttime"
          type="datetime"
          align="center">
        </el-date-picker>
      </el-row>

      <el-row class="rollback-upload-row">
        <el-upload :on-change="onChangeRollbackFile"
                   class="rollback-upload"
                   action=""
                   accept=".xlsx,.xls"
                   :on-remove="onRemoveRollbackUploadFile"
                   :auto-upload="false">
          <el-button slot="trigger"
                     size="small"
                     class="rollback-upload-button"
                     type="primary">上传文件
          </el-button>
        </el-upload>
        <el-button size="small" type="text" @click="downBatchRollbackTpl">下载模板
        </el-button>
      </el-row>

      <el-row class="rollback-upload-row submit-panel">
        <el-button size="small"
                   @click="onCancelRollback">取消
        </el-button>
        <el-button type="primary"
                   size="small"
                   @click="onSubmitRollback">提交
        </el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      withdrawtype: '2,3',
      isconfirm_map: {
        map: [
          {key: 1, value: '已确认'},
          {key: 2, value: '已回滚'},
          {key: 3, value: '部分确认'},
          {key: 4, value: '部分回滚'},
          {key: 5, value: '财务处理中'},
        ],
      },
      dialogWithdrawTableVisible: false,
      dialogBatchRollbackFormVisible: false,
      batchDetailTable: [],
      batchRollbackForm: {
        id: '',
        file: null,
        fileList: [],
        starttime: '',
      },
      batch_id: 0,
      uids: [],
      user_id: null
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.setWithdrawtype()
  },
  updated () {
    this.setWithdrawtype()
  },
  watch: {
  },
  methods: {
    ...Vuex.mapActions(['downBatchSourceFile']),
    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData (params) {
      return request.page('batchWithdrawBatchList', {
        ...params,
        withdrawtype: this.withdrawtype,
      })
    },
    setWithdrawtype () {
      if (this.$route.meta.title === '银行卡提现批次管理') {
        this.withdrawtype = '0,2,3'
      } else if (this.$route.meta.title === '支付宝提现批次管理') {
        this.withdrawtype = '1,4,5'
      } else if (this.$route.meta.title === '微信提现批次管理') {
        this.withdrawtype = '6'
      }
    },
    onDownSourceFile (id) {
      return request.common('batchWithdrawBatchSummary', id).then((data) => {
        this.onExportRows(id, data.data.data)
      })
    },
    getWithdrawBatchTable (id) {
      this.user_id = null
      this.dialogWithdrawTableVisible = true
      this.batch_id = id
      request.common('batchWithdrawBatchDetail', id).then((data) => {
        let table = []
        data.data.data.forEach((row, index) => {
          table.push(row)
        })
        this.batchDetailTable = table
      })
    },
    onExportRows (id, array) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: this.downBatchSourceFile,
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          if (data.current_page === 1) {
            data.data.unshift.apply(data.data, array)
          } else {
            data.data.splice(0, 1)
          }
          return data
        },
      })
    },

    showBatchRollbackForm (id) {
      this.batchRollbackForm.id = id
      this.dialogBatchRollbackFormVisible = true
    },

    onClosedBatchRollbackForm () {
      this.batchRollbackForm.id = ''
      this.batchRollbackForm.file = null
      this.batchRollbackForm.starttime = ''
      this.batchRollbackForm.fileList.splice(0)
    },

    onCheckRollbackFile (file) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        return false
      }

      return true
    },

    onChangeRollbackFile (file, fileList) {
      this.batchRollbackForm.fileList = fileList

      if (!this.onCheckRollbackFile(file)) {
        fileList.splice(0)
        this.batchRollbackForm.file = null
      } else {
        fileList.splice(0, fileList.length - 1)
        this.batchRollbackForm.file = file
      }
    },

    onRemoveRollbackUploadFile (file, fileList) {
      this.batchRollbackForm.fileList = fileList
      this.batchRollbackForm.file = null
    },

    onCancelRollback () {
      this.dialogBatchRollbackFormVisible = false
    },

    downBatchRollbackTpl () {
      let demo = [{
        'user_id': '1219206',
        'fail_reason': '银行账号有误',
      }]
      const fileHeader = [
        {key: 'user_id', text: '用户ID'},
        {key: 'fail_reason', text: '退回原因'},
      ]
      this.$export('批量回滚模板', demo, {fileHeader})
    },

    onSubmitRollback () {
      if (!this.batchRollbackForm.file) {
        this.$message.error('请选择合适的上传文件!')
        return
      } else if (!this.batchRollbackForm.starttime) {
        this.$message.error('请选择开始时间!')
        return
      }

      let data = new FormData()
      data.append('file', this.batchRollbackForm.file.raw)
      data.append('starttime', this.batchRollbackForm.starttime)

      return request.common('uploadBatchRollback', {
        id: this.batchRollbackForm.id,
        data,
      }).then((res) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.dialogBatchRollbackFormVisible = false
        this.onSearch()
      })
    },
    withdrawWx (batchid) {
      let params = {id: batchid, withdrawtype: this.withdrawtype}
      this.$confirm('你确定要批量打款吗？', '提示', {type: 'warning'}).then(() => {
        request.common('withdrawWx', params).then(() => {
          this.$message.success('批量打款任务创建成功')
          this.onSearch()
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    }
  },
}
</script>


<style lang="scss"
       scoped>
.rollback-upload-dialog {

  .rollback-upload-row {
    margin: 0 0 20px;

    &.submit-panel {
      text-align: center;
      margin: 30px 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/finance/pages/BankWithdrawTable.vue